/*****************************************************************************/
/*  File Name: pdfModule.js                                                  */
/*  Date:      Jan 30, 2025                                                  */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This page will alert the user that their pdf is being made    */
/*             and emailed to them                                           */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';
import { useUserContext } from '../../context/userContext';
import { useROIContext } from '../../context/roiContext';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';


function PDFModule({ t }) {
  //Load all of the default component varaibles

  const { user } = useUserContext();
  const { pdfModule, setPDFModule, pdfError, setPDFError } = useROIContext();

  const closeDialog = () => {
    setPDFModule(false);
    setPDFError(null);
  };

  return (
    <Dialog
        open={pdfModule}
        onClose={closeDialog}
      >
        <DialogTitle>{pdfError ? pdfError.title : 'ROI PDF'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {pdfError ? (
              pdfError.message
            ) : (
              <>
                Your ROI PDF is being processed. It will be emailed to {user.email}.
                <br/><br/>
                Please look for an email from orders-solta@soltaautoship.com
              </>
            )}
          </DialogContentText>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Close</Button>
          
        </DialogActions>
      </Dialog>

    
  );
}

export default withTranslation()(PDFModule);
